import { Actions, createEffect, ofType } from '@ngrx/effects';
import { TimeCardService } from '../time-card.service';
import { LoggingService } from '../../shared/services/logging/logging.service';
import { Injectable } from '@angular/core';
import * as fromTCSubmit from './time-card-submit.actions';
import * as fromTimecard from './time-card.actions';
import { tap, catchError, switchMap } from 'rxjs/operators';
import { of } from 'rxjs';
import { ToasterService } from '../../toaster/service';
import { Store } from '@ngrx/store';
import * as fromTimecardR from './time-card.reducer';
import moment from 'moment';

@Injectable()
export class TimeCardSubmitEffects {
    constructor(
        private actions$: Actions,
        private service: TimeCardService,
        private log: LoggingService,
        private toaster: ToasterService,
        private store: Store<fromTimecardR.State>
    ) {}

    putTimeCardSubmit$ = createEffect(
        () =>
            this.actions$.pipe(
                ofType(fromTCSubmit.putTimeCardSubmit),
                tap(a =>
                    this.log.verbose({
                        type: 'TimeCardSubmitEffects:putTimeCardSubmit$',
                        a
                    })
                ),
                switchMap(x =>
                    this.service.putTimeCardSubmit(x.timeCardSubmit).pipe(
                        tap(() => {
                            this.toaster.pop(
                                'success',
                                'Time signed',
                                'Your time has been signed successfully.'
                            );
                            const firstSubmit = x.timeCardSubmit?.[0];
                            if (firstSubmit) {
                                this.store.dispatch(
                                    fromTimecard.getTimeCards({
                                        EmployeeListID: firstSubmit.EmployeeListID,
                                        TimeCardDate:
                                            firstSubmit.StartDate === ''
                                                ? moment(new Date()).format(
                                                      'MM/DD/YYYY'
                                                  )
                                                : moment(
                                                      firstSubmit.StartDate
                                                  ).format('MM/DD/YYYY'),
                                        MyDirection: null
                                    })
                                );
                            }
                        }),
                        catchError(err => {
                            this.log.error({
                                type: 'TimeCardSubmitEffects:putTimeCardSubmit$',
                                error: err
                            });
                            const message =
                                err?.error?.InnerException?.ExceptionMessage ||
                                err?.error?.ExceptionMessage ||
                                err?.error?.message ||
                                err?.error?.Message ||
                                err?.message ||
                                err?.statusText ||
                                'Your time could not be signed. Please try again.';
                            this.toaster.pop(
                                'error',
                                'Time not signed',
                                message
                            );
                            return of(undefined);
                        })
                    )
                )
            ),
        { dispatch: false }
    );
}
